import React, { useEffect, useState } from 'react';
import TableItem from './table-item';
import BTCIcon from './btc.svg'
import ETHIcon from './eth.png'
import BNBIcon from './bnb.svg'
import SOLIcon from './sol.svg'
import USDC from './usdc.svg'
import XRPIcon from './xrp.svg'

const COINS = [
    { id: 'BTC', name: 'Bitcoin', icon: BTCIcon },
    { id: 'ETH', name: 'Ethereum', icon: ETHIcon },
    { id: 'BNB', name: 'Binance Coin', icon: BNBIcon },
    { id: 'SOL', name: 'Solana', icon: SOLIcon },
    { id: 'USDC', name: 'USDC', icon: USDC },
    { id: 'XRP', name: 'XRP', icon: XRPIcon },
];

const TableComponent = () => {
    const [data, setData] = useState({});
    const [sparklineData, setSparklineData] = useState({});

    // Функция для получения данных с Binance
    const fetchData = async () => {
        try {
            const allData = {};
            const sparklineDataObj = {};

            for (const coin of COINS) {
                // Собираем символ для пары USDT (например, BTCUSDT)
                const symbol = coin.id + 'USDT';

                // Запрос 24-часовой статистики
                const tickerResponse = await fetch(
                    `https://api.binance.com/api/v3/ticker/24hr?symbol=${symbol}`
                );
                const tickerData = await tickerResponse.json();

                // Binance возвращает значения в виде строк, поэтому преобразуем их в числа
                allData[coin.id] = {
                    price: parseFloat(tickerData.askPrice),
                    change: parseFloat(tickerData.priceChangePercent),
                    volume: parseFloat(tickerData.volume),
                    marketCap: parseFloat(tickerData.count)
                };

                // Запрос исторических данных (свечей) для формирования sparkline
                const klineResponse = await fetch(
                    `https://api.binance.com/api/v3/klines?symbol=${symbol}&interval=1d&limit=30`
                );
                const klineData = await klineResponse.json();

                // Каждая свеча — это массив, где индекс 4 соответствует цене закрытия
                const sparkline = klineData.map(item => parseFloat(item[4]));
                sparklineDataObj[coin.id] = sparkline;
            }

            setData(allData);
            setSparklineData(sparklineDataObj);
        } catch (error) {
            console.error('Ошибка при получении данных с Binance:', error);
        }
    };

    useEffect(() => {
        fetchData();

        const interval = setInterval(() => {
            fetchData();
        }, 60000); // Обновление данных раз в минуту

        return () => clearInterval(interval);
    }, []);

    return (
        <div className='table' data-aos='fade-up'>
            <div className='table__top'>
                <div className='table__item'>Market</div>
                <div className='table__item'>Price</div>
                <div className='table__item'>Change</div>
                <div className='table__item'>Market cap</div>
                <div className='table__item'>Volume 24h</div>
                {/*<div className='table__item'>{t('table_block.table_title6')}</div>*/}
                <div className='table__item'></div>
            </div>

            <div className='table__body'>
                {COINS.map((coin) => (
                    <TableItem
                        key={coin.id}
                        name={coin.name}
                        // Если нужны иконки, можно добавить статические URL или локальные изображения
                       icon={coin.icon}
                        data={data[coin.id]}
                        sparklineData={sparklineData[coin.id]}
                    />
                ))}
            </div>
        </div>
    );
};

export default TableComponent;
